import { useMutation, useQueryClient } from 'react-query';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts'; // Ensure this path is correct
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface CaseMetadata {
  name?: string;
  type?: string;
  legalIssues?: string;
  parties?: string;
  disputeStatus?: string;
  keyTimePeriod?: string;
  keyContext?: string;
  billable?: boolean;
}
interface UseUpdateCaseMetadata {
  caseId: string;
  data: CaseMetadata;
}

const useUpdateCaseMetadata = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ caseId, data }: UseUpdateCaseMetadata) => {
      const response = await fetch(
        `${APIBaseChronos}/api/case/${caseId}/metadata`,
        getFetchConfig({ method: FetchMethod.PATCH, data }),
      );

      if (!response.ok) {
        throw new Error('Failed to update case metadata');
      }
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Case, variables.caseId] });
    },
  });
};

export default useUpdateCaseMetadata;
